export enum EnvNameEnum {
  PROD = 'prod',
  QA = 'qa',
  DEV = 'dev',
}
